import { Server } from 'miragejs';

import { FilterType } from 'features/Filters/types/Filters';
import { frames } from 'mocks/server/data/frames';
import { linkedAssets } from 'mocks/server/data/linkedAssets';
import { generateLiveFrameFilters } from 'mocks/server/utils/generateLiveFrameFilters';
import { FILTERS_API_URL, IMPORT_API_URL } from 'utils/defaults';

import { generateDraftFrames } from '../data/draftFrames';
import { generateDraftLinkedAssets } from '../data/draftLinkedAssets';
import { generateDraftEntityFilters } from '../utils/generateDraftEntityFilters';
import { generateLiveEntityFilters } from '../utils/generateLiveEntityFilters';
import { generateLiveLinkedAssetFilters } from '../utils/generateLiveLinkedAssetFilters';

export const otherRoutes = (server: Server) => {
  server.post(IMPORT_API_URL, (schema, request) => {
    const spaceIds = JSON.parse(request.requestBody);
    return { spaceIds };
  });

  server.get(FILTERS_API_URL, (schema, request) => {
    const type = request.queryParams.type as FilterType;

    switch (type) {
      case FilterType.FRAMES:
        return generateLiveFrameFilters(frames);
      case FilterType.LINKED_ASSETS:
        return generateLiveLinkedAssetFilters(linkedAssets);
      case FilterType.DRAFTS:
        return generateDraftEntityFilters(generateDraftFrames(), generateDraftLinkedAssets());
      case FilterType.LIVE_ENTITIES:
        return generateLiveEntityFilters(frames, linkedAssets);
      default:
        return {};
    }
  });
};
